import { render, staticRenderFns } from "./EventWorkerCheckboxInputGroup.vue?vue&type=template&id=380d38e4&"
import script from "./EventWorkerCheckboxInputGroup.vue?vue&type=script&lang=ts&"
export * from "./EventWorkerCheckboxInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports